import { getCreditCardNumberPreview, getCreditCardType } from 'shared/utils'
import DeleteButton from '@components/DeleteButton'
import Icon from '@components/Icon'
import CircleLoader from '@components/CircleLoader'

const ListItem = ({ default: isDefault, nickName, cardLast4, cardType, onDelete, setDefault, expDate, pending }) => (
    <li className="d-flex" onClick={setDefault}>
        <Icon type={getCreditCardType(cardType)} className="mr-3" size="sm" withShadow />
        <span className="title mr-2">
            {getCreditCardNumberPreview({ nickName, cardLast4, expDate })}{' '}
            <>
                {isDefault && <Icon className="default-card" type="checked_new" />}
                <DeleteButton onClick={onDelete} />
            </>
        </span>
        {pending && <CircleLoader className="ml-2 mt-1" size="small" />}
    </li>
)

export default ListItem
